module.exports = __webpack_public_path__ + "1495c9d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/map_marker_3.png
// module id = 1673
// module chunks = 0